import { getApiUrl } from './apiBaseUrl'

const xhrFormDataRequest = ({ url, method = 'POST', formData, onProgress }) => new Promise((resolve, reject) => {
  const xhr = new XMLHttpRequest()

  if (onProgress) {
    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        onProgress(event.loaded, event.total)
      }
    })
  }

  xhr.addEventListener('load', () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      try {
        resolve(xhr.responseText ? JSON.parse(xhr.responseText) : {})
      } catch {
        resolve({})
      }
      return
    }
    reject(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`))
  })

  xhr.addEventListener('error', () => {
    reject(new Error('Network error'))
  })

  xhr.addEventListener('abort', () => {
    reject(new Error('Upload aborted'))
  })

  xhr.open(method, getApiUrl(url))
  xhr.setRequestHeader('Accept', 'application/json')
  xhr.withCredentials = true
  xhr.send(formData)
})

export default xhrFormDataRequest
